export function loadImage(src: string) {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.onload = resolve
    image.src = src
    image.onerror = reject
  })
}

export function isImageCached(src: string) {
  const image = new Image()
  image.src = src
  const cached = image.complete || image.height + image.width > 0
  image.src = ''
  return cached
}
